'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var $ = require("jquery");
var Form = /** @class */ (function () {
    function Form() {
        var _this = this;
        // 空白チェック項目
        this.notNullKeys = ['your_name', 'your_name_kana', 'email', 'email_re', 'body', 'accept'];
        $('.trigCheckForm').on('click', function (event) {
            // エラー表示のリセット
            _this.notNullKeys.forEach(function (key) {
                $('.bulletContactErrorMessage[data-name="' + key + '"]').attr('data-error', '0');
            });
            $('.bulletContactErrorMessage[data-name="email_re_not_matched"]').attr('data-error', '0');
            // バリデーション
            var values = _this.getValues();
            _this.validates(values, event);
        });
    }
    Form.prototype.getValues = function () {
        return {
            your_name: $('input[name="your_name"]').val(),
            your_name_kana: $('input[name="your_name_kana"]').val(),
            email: $('input[name="email"]').val(),
            email_re: $('input[name="email_re"]').val(),
            body: $('textarea[name="body"]').val(),
            accept: $('input[name="accept"]:checked').val()
        };
    };
    Form.prototype.validates = function (values, event) {
        var _this = this;
        var errorFlags = [];
        // 値の数だけスペースを確保
        this.notNullKeys.forEach(function () {
            errorFlags.push(false);
        });
        //console.log('errorFlags', errorFlags);
        // 空白
        this.notNullKeys.forEach(function (key, index) {
            if (_this.isNull(values[key])) {
                $('.bulletContactErrorMessage[data-name="' + key + '"]').attr('data-error', '1');
                errorFlags[index] = true;
            }
        });
        // フリガナ
        if (!this.isKana(values.your_name_kana)) {
            $('.bulletContactErrorMessage[data-name="your_name_kana"]').attr('data-error', '1');
            errorFlags[1] = true;
        }
        // メールアドレス
        if (!this.isEmailFormat(values.email)) {
            $('.bulletContactErrorMessage[data-name="email"]').attr('data-error', '1');
            errorFlags[2] = true;
        }
        // 確認用メールアドレス
        if (!this.isEmailFormat(values.email_re)) {
            $('.bulletContactErrorMessage[data-name="email_re"]').attr('data-error', '1');
            errorFlags[3] = true;
        }
        else if (this.isEmailFormat(values.email_re) && values.email != values.email_re) { // メールアドレス不一致
            $('.bulletContactErrorMessage[data-name="email_re_not_matched"]').attr('data-error', '1');
            errorFlags[3] = true;
        }
        // 1番最初にエラーがあった位置を取得
        var firstErrorIndex = $.inArray(true, errorFlags);
        //console.log('errorFlags_re', errorFlags);
        //console.log('firstErrorIndex', firstErrorIndex);
        // エラー時処理
        if (firstErrorIndex !== -1) {
            // フォーム処理中断
            event.preventDefault();
            // エラーメッセージまでの移動
            this.scrollToErrorMessage(this.notNullKeys[firstErrorIndex]);
            return false;
        }
    };
    // エラーメッセージ箇所までの移動
    Form.prototype.scrollToErrorMessage = function (errorName) {
        //console.log('errorName', errorName);
        var formPosition = $('.bulletScrollToErrorMessage[data-name="' + errorName + '"]').offset().top;
        $('html, body').animate({
            scrollTop: formPosition
        }, 'slow');
    };
    // 空白チェック
    Form.prototype.isNull = function (val) {
        return this.removeSpace(val) == '';
    };
    // 空白文字の削除
    Form.prototype.removeSpace = function (val) {
        return val ? val.replace(/\s+/g, '') : '';
    };
    // 全角カナ、全角スペース、半角カナ、半角スペースならtrueを返す
    Form.prototype.isKana = function (val) {
        return !!val.match(/^[ァ-ヶー　ｦ-ﾟ ]*$/);
    };
    // メールアドレスの形式かどうか判定
    Form.prototype.isEmailFormat = function (val) {
        return val.match(/^[0-9a-zA-Z]+[0-9a-zA-Z\-\+_\.]+@[0-9a-zA-Z\-\+_\.]+\.[0-9a-zA-Z\-\+_\.]+$/g);
    };
    return Form;
}());
exports.Form = Form;
exports.default = Form;
